module.exports = __webpack_public_path__ + "static/img/2968338.3b7536a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/2968338.svg
// module id = Xz7N
// module chunks = 1